import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-pdf-to-excel',
    imports: [],
    templateUrl: './blog-pdf-to-excel.component.html',
    styleUrl: './blog-pdf-to-excel.component.css'
})
export class BlogPdfToExcelComponent {

}
